export default {
    props: {
        validationAllowedExtensions: {
            type: Array,
            kComposite: 'validation.allowedExtensions'
        }, 
        validationMaxFileSize: {
            type: Number,
            kComposite: 'validation.maxFileSize'
        }, 
        validationMinFileSize: {
            type: Number,
            kComposite: 'validation.minFileSize'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/Validation.js